import { render, staticRenderFns } from "./Clarification.vue?vue&type=template&id=53a7ab9e"
import script from "./Clarification.vue?vue&type=script&lang=js"
export * from "./Clarification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports